import { useMemo } from 'react';

export const isOwnerLifetales = entity =>
  entity && entity.member && entity.member.id === process.env.REACT_APP_LT_MEMBER_ID;

const useIsOwnerLifetales = entity => useMemo(() => isOwnerLifetales(entity), [entity]);

export default useIsOwnerLifetales;
